import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { appInitGuard } from './guards/initApp/app-init.guard';

const routes: Routes = [
  {
    path: '',
    canActivate: [appInitGuard],
    loadComponent: () => import('./layouts/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'register/:token',
    loadComponent: () => import('./layouts/register/register.component').then(m => m.RegisterComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./layouts/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: '2fa-verification',
    loadComponent: () => import('./modules/communs/users/towfa-verification/towfa-verification.component').then(m => m.TowfaVerificationComponent),
  },
  {
    path: '',
    loadComponent: () => import('./layouts/dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivateChild: [authGuard],
    children: [
      {
        path: 'users/invitation',
        loadChildren: () =>
          import('./modules/invitations/invitations.module').then(
            (m) => m.InvitationsModule,
          ),
        data: { requiresPermission: ['USRMGM', 'admintnegoce'] },
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./modules/communs/dashboard/dashboard.module').then(
            (m) => m.DashboardModule,
          ),
        data: { requiresPlatform: [3] },
      },
      {
        path: 'platformdashboard',
        loadChildren: () =>
          import('./modules/communs/dashboard/dashboard.module').then(
            (m) => m.DashboardModule,
          ),
      },
      {
        path: 'stats',
        loadChildren: () =>
          import('./modules/stats/stats.module').then((m) => m.StatsModule),
        data: { requiresPermission: ['STATS'], requiresPlatform: [1, 2] },
      },
      {
        path: 'dashboard/corporates',
        loadChildren: () =>
          import('./modules/communs/corporates/corporates.module').then(
            (m) => m.CorporatesModule,
          ),
      },
      {
        path: 'contrat',
        loadChildren: () =>
          import('./modules/communs/contrat/contrat.module').then(
            (m) => m.ContratModule,
          ),
        data: { requiresPermission: ['admintnegoce'] },
      },
      {
        path: 'refdel',
        loadChildren: () =>
          import('./modules/communs/refdel/refdel.module').then(
            (m) => m.RefdelModule,
          ),
        data: { requiresPermission: ['admintnegoce'] },
      },
      {
        path: 'file',
        loadChildren: () =>
          import('./modules/communs/upload-file/upload-file.module').then(
            (m) => m.UploadFileModule,
          ),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./modules/communs/users/users.module').then(
            (m) => m.UsersModule,
          ),
      },
      {
        path: 'clientMangement',
        loadChildren: () =>
          import('./modules/client-mangement/client-mangement.module').then(
            (m) => m.ClientMangementModule,
          ),
        data: { requiresPermission: ['admintnegoce'] },
      },
      {
        path: 'bank',
        loadChildren: () =>
          import('./modules/bank-management/bank-management.module').then(
            (m) => m.BankManagementModule,
          ),
      },
      {
        path: 'corporate',
        loadChildren: () =>
          import('./modules/corporate-management/corporate-management.module').then(
            (m) => m.CorporateManagementModule,
          ),
      },
      {
        path: 'corpo',
        loadChildren: () =>
          import('./modules/request/request.module').then(
            (m) => m.RequestModule,
          ),
      },
      {
        path: 'deal',
        loadChildren: () =>
          import('./modules/deal-management/deal-management.module').then(
            (m) => m.DealManagementModule,
          ),
      },
      {
        path: 'oc',
        loadChildren: () =>
          import('./modules/operation-commerciale/operation-commerciale.module').then(
            (m) => m.OperationCommercialeModule,
          ),
        data: { requiresPermission: ['VIEWCO', 'ADDCO', 'EDITCO'] },
      },
      {
        path: 'ServiceManagement',
        loadChildren: () =>
          import('./modules/service-management/service-management.module').then(
            (m) => m.ServiceManagementModule,
          ),
      },
      {
        path: 'mapping',
        loadChildren: () =>
          import('./modules/mapping-module/mapping-module.module').then(
            (m) => m.MappingModuleModule,
          ),
      },
      {
        path: 'documents',
        loadComponent: () => import('./modules/document-management/document-management-list/document-management-list.component').then(m => m.DocumentManagementListComponent),
        data: { requiresPermission: ['MNGDOC'] },
      },
      {
        path: 'doc-check',
        loadChildren: () =>
          import('./modules/document-check/document-check.module').then(
            (m) => m.DocumentCheckModule,
          ),
        data: { requiresPermission: ['DCCHK'] },
      },
      {
        path: 'BTB',
        loadChildren: () =>
          import('./modules/request-btb/request-btb.module').then(
            (m) => m.RequestBTBModule,
          ),
      },
      {
        path: 'jobs-configuration',
        loadChildren: () =>
          import('./modules/communs/configuration/configuration.module').then(
            (m) => m.ConfigurationModule,
          ),
        data: { requiresPlatform: [0] },
      },
      {
        path: 'julia-configuration',
        loadChildren: () =>
          import('./modules/julia-agent/julia-management/julia-management.module').then(
            (m) => m.JuliaManagementModule,
          ),
        data: { requiresPlatform: [0] },
      },
      {
        path: 'markets',
        data: {
          requiresPlatform: [2],
        },
        loadChildren: () =>
          import('./modules/market-management/market-management.module').then(
            (m) => m.MarketManagementModule,
          ),
      }
    ],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules
  })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
